import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const ensureUserId = () => {
  let id = localStorage.getItem("lumen_user_id");
  if (!id) {
    id = "u_" + Math.random().toString(36).slice(2, 10);
    localStorage.setItem("lumen_user_id", id);
  }
  return id;
};

export const getName = () => localStorage.getItem("lumen_name") || "Explorer";
export const setName = (n) => localStorage.setItem("lumen_name", n);
